import styled, { keyframes } from 'styled-components';

import S from '../variables';

const arrive = keyframes`
0% {
    transform: translateX(-100%);
    opacity: 0.2;
}
100% {
  transform: translateX(0);
    opacity: 1;
}
`;

export const StyledInput = styled.input`
  background: ${S.greyBg};
  height: ${props => (props.as === 'textarea' ? 350 : 45)}px;
  resize: none;
  width: 100%;
  border-radius: 5px;
  font-size: 12px;
  color: ${S.mainGreyText};
  padding: 15px;
  border: 1px solid ${S.greyBg};
  outline: none;
  &.correct {
    background: #fff;
    border: 1px solid ${S.secondaryGreyBg};
  }
  &.error,
  &.error:focus,
  &.error:hover {
    color: ${S.redText};
    border-color: ${S.redText};
  }
  &:hover {
    border-color: ${S.mainGreyText};
    outline: none;
  }
  &:focus {
    border-color: ${S.mainBlackText};
    outline: none;
  }
  &[disabled] {
    cursor: not-allowed;
    border-color: ${S.disabledBorder};
    color: ${S.disabledBorder};
    background: #fff;
  }
  &[disabled]::placeholder {
    color: ${S.disabledBorder};
  }
`;

export const StyledMainInput = styled.div`
  position: relative;
  height: ${props => (props.element === 'textarea' ? 365 : 60)}px;
  padding-bottom: 15px;
  overflow: hidden;
  & > .errors-container {
    display: none;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 12px;
    line-height: 15px;
    color: ${S.redText};
  }
  & > input.error + .errors-container {
    display: block;
    animation: 500ms ${arrive} ease-out;
  }
  &.form__input > input[disabled],
  &.form__input > textarea[disabled] {
    color: ${S.mainBlackText};
  }
`;

export const StyledPairInput = styled.div`
  position: relative;
  display: inline-flex;
  justify-content: space-between;
  width: ${props => props.wd || '100%'};
  height: 45px;
  &::after {
    content: '';
    position: absolute;
    top: 23px;
    left: 50%;
    transform: translateX(-50%);
    width: 15px;
    height: 1px;
    background: ${S.mainGreyText};
  }
  & .input {
    width: calc((100% - 32px) / 2);
  }
`;
